import React from 'react';
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import Stack from '@mui/material/Stack';
import styled, { css } from 'styled-components';

interface PaginationComponentProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const StyledPagination = styled(Pagination)`
  ${({ theme }) => css`
    & .MuiPaginationItem-root {
      border-radius: 3.2px;
      border: 0.8px solid ${theme.secondaryButtonBorderColor};
      background: ${theme.secondaryButtonBackground};
      color: ${theme.playerColor};
      text-align: center;
      font-feature-settings: 'clig' off, 'liga' off;

      /* DM-Mono/Title/Small */
      font-family: "DM Mono";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px; /* 100% */
      text-transform: uppercase;
      // Custom styles for pagination item
    },
    & .MuiPagination-ul > li {
      
    }
    & .Mui-selected {
      // Custom styles for selected pagination item
    },
    & .MuiPagination-ul {
      gap: 8px;
    }
    & .MuiPaginationItem-root.Mui-selected {
      border-radius: 4px;
      border: 0.5px solid rgba(17, 17, 17, 0.25);
      background: var(--Brand-green-1-500, #00D1A8);
      color: var(--Brand-black-500, #111);
    }
    & .MuiPaginationItem-root.Mui-selected:hover {
      border-radius: 4px;
      border: 0.5px solid rgba(17, 17, 17, 0.25);
      background: var(--Brand-green-1-500, #00D1A8);
    }
    & .MuiPaginationItem-root:hover {
      border-radius: 4px;
      border: 0.5px solid rgba(17, 17, 17, 0.25);
      background: var(--Brand-green-1-500, #00D1A8);
    }
    & .MuiPaginationItem-rounded.MuiPaginationItem-ellipsis{
      border: none;
      background: none;
    }
  `}
`;



const PaginationComponent: React.FC<PaginationComponentProps> = ({ totalPages, currentPage, onPageChange }) => {

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    onPageChange(value);
  };

  return (
    <StyledPagination
      count={totalPages}
      page={currentPage}
      onChange={handleChange}
      variant="outlined"
      shape="rounded"
    />
  );
};

export default PaginationComponent;
